import api from '../../shared/api/client';
import { API_ROUTES } from '../../shared/api/routes';

export const controllerApi = {
  transitionLifecycle: (id, data) => api.post(API_ROUTES.controllers.lifecycle(id), data),
  getControllers: (params) => api.get(API_ROUTES.controllers.base, { params }),
  getDevices: (params) => api.get(API_ROUTES.controllers.base, { params }),
  getControllerById: (id) => api.get(API_ROUTES.controllers.detail(id)),
  getControllerConfigs: (id) => api.get(API_ROUTES.controllers.configs(id)),
  getControllerIncidents: (id, params) => api.get(API_ROUTES.controllers.incidents(id), { params }),
  createCommand: (id, data) => api.post(API_ROUTES.controllers.command(id), data),
  requestCommandApproval: (id, data) => api.post(API_ROUTES.controllers.commandApproval(id), data),
  approveCommandApproval: (approvalId) => api.post(API_ROUTES.adminApprovals.approve(approvalId), {}),
  getCommandApproval: (approvalId) => api.get(API_ROUTES.adminApprovals.controllerCommand(approvalId)),
  getPendingCommandApprovals: (controllerId) =>
    api.get(API_ROUTES.adminApprovals.pendingControllerCommands, {
      params: { controller_id: controllerId },
    }),
  getNextDeviceId: (societyId) => api.get(API_ROUTES.controllers.nextDeviceId, { params: { societyId } }),
  getHealthSummary: (params) => api.get(API_ROUTES.controllers.healthSummary, { params }),
  createController: (data) => api.post(API_ROUTES.controllers.base, data),
  issueClaimToken: (id, data) => api.post(API_ROUTES.controllers.claimToken(id), data),
  updateController: (id, data) => api.put(API_ROUTES.controllers.detail(id), data),
  deleteController: (id, data) => api.delete(API_ROUTES.controllers.detail(id), { data }),
};
